module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/entrance-arrow.9385de0d.svg";